import React from 'react';
import PropTypes from 'prop-types';
import { alpha, Button as RealButton } from "@mui/material";
import { Colors } from 'shared/constants/AppEnums';

// Note | Task: Style button sesuai props type belum sesuai dan belum lengkap. Akan dilengkapi setelah design update.

const Button = ({
    type = 'primary', // none, primary, secondary, netral, accent, warning, danger, info-primary
    size = 'medium', // small, medium, large,
    variant = 'contained', // contained, outlined,
    label = 'Label',
    onClick = () => { },
    children,
    disabled = false,
    icon,
    iconPosition,
    ...rest
}) => {

    const buttonStyle = {
        'none': {},
        'primary': {
            'contained': {
                color: Colors.white,
                background: Colors.primary,
                '&:hover': {
                    background: alpha(Colors.primary, 0.9)

                }
            },
            'outlined': {
                color: Colors.primary,
                borderColor: Colors.primary,
                '&:hover': {
                    borderColor: alpha(Colors.primary, 0.8),
                    backgroundColor: '#fff',
                },
            }
        },
        'secondary': {
            color: Colors.white,
            background: Colors.secondary,
            '&:hover': {
                background: alpha(Colors.secondary, 0.8)
            }
        },
        'netral': {
            'contained': {
                color: Colors.black,
                background: Colors.white,
                '&:hover': {
                    background: alpha(Colors.black, 0.1)
                }
            },
            'outlined': {
                color: Colors.white,
                borderColor: Colors.black,
                '&:hover': {
                    borderColor: alpha(Colors.black, 0.1),
                    backgroundColor: '#fff',
                },
            },
        },
        'info': {
            'contained': {
                color: Colors.white,
                background: Colors.info,
                '&:hover': {
                    background: alpha(Colors.info, 0.9)
                }
            },
            'outlined': {
                color: Colors.primary,
                borderColor: Colors.info,
                '&:hover': {
                    borderColor: alpha(Colors.info, 0.9),
                    backgroundColor: '#fff',
                },
            }
        },
        'warning': {
            'contained': {
                color: Colors.white,
                background: Colors.warning,
                '&:hover': {
                    background: alpha(Colors.warning, 0.9)

                }
            },
            'outlined': {
                color: Colors.warning,
                borderColor: Colors.warning,
                '&:hover': {
                    borderColor: alpha(Colors.warning, 0.8),
                    backgroundColor: '#fff',
                },
            }
        },
        'danger': {
            'contained': {
                color: Colors.white,
                background: Colors.danger,
                '&:hover': {
                    background: alpha(Colors.danger, 0.9)
                }
            },
            'outlined': {
                color: Colors.primary,
                borderColor: Colors.danger,
                '&:hover': {
                    borderColor: alpha(Colors.danger, 0.9),
                    backgroundColor: '#fff',
                },
            }
        },
        'success': {
            'contained': {
                color: Colors.white,
                background: Colors.success,
                '&:hover': {
                    background: alpha(Colors.success, 0.9)
                }
            },
            'outlined': {
                color: Colors.primary,
                borderColor: Colors.success,
                '&:hover': {
                    borderColor: alpha(Colors.success, 0.9),
                    backgroundColor: '#fff',
                },
            }
        }
    }

    if (children) {
        return (
            <RealButton
                size={size}
                variant={variant}
                disabled={disabled}
                sx={[buttonStyle[type][variant], { boxShadow: 'none', display: 'flex', alignItems: 'center', gap: 2, flexDirection: iconPosition && iconPosition === 'right' ? 'row-reverse' : 'row', alignItems: 'center', ...rest.sx }]}
                onClick={(e) => onClick(e)}
                {...rest}
            >
                {icon && icon}
                {children}
            </RealButton>
        )
    }

    return (
        <RealButton
            size={size}
            variant={variant}
            disabled={disabled}
            sx={[buttonStyle[type][variant], { boxShadow: 'none', display: 'flex', flexDirection: iconPosition && iconPosition === 'right' ? 'row-reverse' : 'row', alignItems: 'center', gap: 2, ...rest.style }]}
            onClick={(e) => onClick(e)}
            {...rest}
        >
            {icon && icon}
            {label}
        </RealButton>
    )
}

Button.propTypes = {
    type: PropTypes.string,
    size: PropTypes.string,
    label: PropTypes.string,
    onClick: PropTypes.func,
    children: PropTypes.node,
    disabled: PropTypes.bool,
    variant: PropTypes.string,
    icon: PropTypes.any,
    iconPosition: PropTypes.string
}

export default Button;
